import { IconName } from '@/components/NeolexonIcon/Icons/types';
import { Pill } from '@/components/Pill';
import { Template as TemplateType } from './types';

const setConfig = {
  Word: {
    icon: 'letter',
    label: 'Wörterset',
  },
  Sentence: {
    icon: 'sentence',
    label: 'Sätzeset',
  },
  Text: {
    icon: 'book',
    label: 'Texteset',
  },
};

const difficultyIconMap = {
  easy: {
    icon: 'weightEasy' as IconName,
    label: 'Leicht',
  },
  medium: {
    icon: 'weightMedium' as IconName,
    label: 'Mittel',
  },
  hard: {
    icon: 'weightHard' as IconName,
    label: 'Schwer',
  },
};

type TemplatePillSectionProps = {
  template: TemplateType;
};

export const TemplatePillSection = ({ template }: TemplatePillSectionProps) => {
  const config = setConfig[template.setType];
  return (
    <>
      <Pill
        label={config.label}
        icon={config.icon as IconName}
        isNeolexon={template.isNeolexonTemplate}
        iconSize={22}
      />
      <Pill
        label={difficultyIconMap[template.difficulty].label}
        icon={difficultyIconMap[template.difficulty].icon}
        isNeolexon={false}
        iconSize={22}
      />
    </>
  );
};
